import { View } from 'backbone.marionette';
import template from './index.jst';
import { Model } from 'backbone';
import './index.styl';
import moment from 'moment';
import { User as UserModel } from '../../../models';
import _ from 'lodash';

export class AdvertisingView extends View {
	get template() {
		return template;
	}

	get className() {
		return 'advertising-wrap';
	}

	initialize() {
		this.model   = new Model();
		this.ad_id   = this.getOption( 'ad_id' );
		this.ad_path = this.getOption( 'ad_path' );
		this.size    = this.getOption( 'size' );
		this.pos     = this.getOption( 'pos' );
		this.slot    = '';
		this.timeout = null;

		this.setModelData();
	}

	setModelData() {
		this.model.set({
			ad_id: this.ad_id
		});

		return this;
	}

	onRender() {
		this.showSlot();
	}

	get over18() {
		const
			birthday = moment(UserModel.get('birthday')),
			age = moment().diff(birthday, 'years');

		return age >= 18;
	}

	get gender() {
		let gender = _.get(UserModel.attributes, 'gender', 'unknown');
		if (gender === '1') {
			gender = 'female';
		}
		if (gender === '0') {
			gender = 'male';
		}

		return gender;
	}

	showSlot() {
		if(
			window.googletag &&
			this.ad_id &&
			this.ad_path &&
			this.size
		) {
			const
				ad_network = process.env.GOOGLE_AD_NETWORK,
				ad_index = process.env.GOOGLE_AD_INDEX,
				ad_url = ad_network+'/'+ad_index+'/'+this.ad_path,
				birthday = moment(UserModel.get('birthday')),
				birthYear = birthday.format('YYYY'),
				age = this.over18 ? 'over18' : 'under18',
				supported_club = UserModel.get('supported_club_name'),
				gender = this.gender;

			window.googletag.cmd.push(() => {
				const pubadsService = window.googletag.pubads();
				// const slot = pubadsService
				// 	.display( ad_url, this.size, this.ad_id );
				// pubadsService.refresh(slot).setTargeting("gen", "unknown");

				this.slot = window.googletag.defineSlot(ad_url, this.size, this.ad_id)
					.setTargeting("gen", gender)
					.setTargeting("clubfav", supported_club)
					.setTargeting("birthYear", birthYear)
					.setTargeting("age", age)
					.setTargeting("pos", this.pos.toString())
					.addService(pubadsService);

				this.timeout = setTimeout(() => pubadsService.refresh([this.slot]), 500);
			});
		}

		return this;
	}

	destroy() {
		if (window.googletag && typeof window.googletag.destroySlots === 'function') {
			window.googletag.destroySlots([this.slot]);
			clearTimeout(this.timeout);
		}
	}
}

export default AdvertisingView;